var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "navbar navbar-default no-margin app-sidebar-nav" },
    [
      _vm.currentEnvironment
        ? _c(
            "div",
            { staticClass: "notification-block notification-block-top" },
            [_vm._m(0)]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "navbar-header fixed-brand",
          staticStyle: { background: "#FFFFFF" }
        },
        [
          _c(
            "button",
            {
              staticClass: "navbar-toggle collapsed",
              attrs: {
                type: "button",
                "data-toggle": "collapse",
                id: "menu-toggle"
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.menuTtoggleMobile(_vm.sidebarType)
                }
              }
            },
            [_c("span", { attrs: { "aria-hidden": "true" } })]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            { staticClass: "navbar-brand", attrs: { to: { path: "/" } } },
            [
              _c("img", {
                attrs: {
                  src: "/static/images/vvg-home-logo.png",
                  alt: "HR Portal"
                }
              })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "collapse navbar-collapse",
          attrs: { id: "bs-example-navbar-collapse-1" }
        },
        [
          _c("ul", { staticClass: "nav navbar-nav" }, [
            _c("li", { staticClass: "active" }, [
              _c(
                "button",
                {
                  staticClass: "navbar-toggle collapse in",
                  attrs: { "data-toggle": "collapse", id: "menu-toggle-2" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.menuTtoggleDesktop(_vm.sidebarType)
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "menubar",
                    attrs: { src: "/static/images/menubar.png", alt: "Menu" }
                  })
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "downloadDirectory btn btn-primary waves-effect pull-left",
              attrs: { type: "button", title: "Download Directory" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.download()
                }
              }
            },
            [
              _c("i", {
                staticClass: "fa fa-download",
                attrs: { "aria-hidden": "true" }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { attrs: { id: "wrap" } }, [
        _c(
          "form",
          {
            attrs: { action: "", autocomplete: "on" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.universalSearchAPI()
              }
            }
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.universalSearchText,
                  expression: "universalSearchText"
                }
              ],
              attrs: {
                id: "search",
                name: "search",
                type: "text",
                placeholder: "Search...",
                required: ""
              },
              domProps: { value: _vm.universalSearchText },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.universalSearchText = $event.target.value
                }
              }
            }),
            _c("input", {
              attrs: {
                id: "search_submit",
                value: "Rechercher",
                type: "submit"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "user-info" }, [
        _c("div", { staticClass: "user-info-container" }, [
          _c("div", { staticClass: "dropdown" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary dropdown-toggle",
                attrs: { type: "button", "data-toggle": "dropdown" }
              },
              [
                _c("div", { staticClass: "dropdown-user" }, [
                  _c("div", { staticClass: "image" }, [
                    _c("img", {
                      attrs: {
                        src: _vm.profile_image,
                        alt: "User",
                        width: "48",
                        height: "48"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-user-right" }, [
                    _c("div", { staticClass: "username" }, [
                      _vm._v(_vm._s(_vm.firstName) + " " + _vm._s(_vm.lastName))
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", { staticClass: "usermailid" }, [
                      _vm._v(_vm._s(_vm.email))
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-menu" }, [
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.logout()
                    }
                  }
                },
                [_vm._v("Logout")]
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "alert alert-primary alert-dismissible",
        attrs: { role: "alert", "aria-live": "polite", "aria-atomic": "true" }
      },
      [
        _c("div", { staticClass: "scroll-left" }, [
          _c("p", [_vm._v("This is Test Environment !")])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26b4e0ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b4e0ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/partials/ExtensionHeader.vue
// module id = null
// module chunks = 